<div id="{{gdFieldId}}Question"
	 *ngIf="gdShowFlag" 
	[ngClass]="gdAddClass" class="febi-tag {{gdDisableHook}}">
	
	<label 
		*ngIf="gdShowLabel" 
		[attr.for]="gdFieldId" 
		[ngClass]="gdHideLabel" 
		[innerHTML]="gdLabel">
	</label>
	
	
	<div class="inputBlock">
		<input id="{{gdFieldId}}" class="form-control" type="text" [(ngModel)]="gdModel" [placeholder]="gdPlaceholder"
			[disabled]="gdDisabled" [attr.maxLength]="gdMaxLength"
			[gdFieldMap]="fieldMap"
			autocomplete="off" (focus)="onFocus($event)" (keydown.tab)="onKeyDown($event)" (input)="onInputHandler($event)"
			/>
		<a id="{{gdFieldId}}ConfirmWebOK" class="btn off gd-custom-input-addon" 
			(click)="confirmWeb(gdFieldId)" href="javascript:undefined" style="display:none;">OK</a>
		
	</div>
	
</div>
